import { Flex, FlexProps, Text } from '@chakra-ui/react'
import { formattedGem } from '../utils/number'
import { CSSProperties } from 'react'

import RushGemIcon from './Icons/RushGemIcon'
import { colors } from '../theme/cssVariables'
import GunIcon from './Icons/GunIcon'

const RushPrice = ({
  useGunIcon = false,
  price = 0,
  hasMin2 = false, // need min $2 deposit
  gemIconStyle,
  priceIcon,
  ...rest
}: {
  useGunIcon?: boolean
  hasMin2?: boolean
  price: number | string
  gemIconStyle?: CSSProperties
  priceIcon?: React.ReactNode
} & FlexProps) => {
  return (
    <Flex alignItems={'center'} gap={'10px'} fontSize={['20px']} color={colors.colorA4} {...rest}>
      {priceIcon ?? (
        <RushGemIcon
          width={gemIconStyle?.width?.toString()}
          height={gemIconStyle?.height?.toString()}
        />
      )}

      <Text>{formattedGem(price)}</Text>
    </Flex>
  )
}

export default RushPrice
